<template>
  <div class="page-container">
    <div class="carousel">
      <el-carousel height="100px">
        <el-carousel-item v-for="item in adImgs" :key="item.value">
          <el-image
            style="width: 100%; height: 100px;"
            :src="item.value"
            :fit="fit"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div class="bindingAlert" v-show="isShowBandingAlert">
        <el-alert
          title="您尚未完成手机和邮件的绑定，将不会启动自动监控和提醒功能，如需开启请您到“个人中心->基本信息”进行绑定"
          type="warning"
          show-icon
          style="margin-bottom:10px;"
        >
        </el-alert>
      </div>
      <el-card class="box-card">
        <div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-card
                shadow="hover"
                class="func-box"
                style="background-color:#409EFF"
                @click.native="turn2Page('list/setting')"
              >
                <div class="func-box-div text-left">
                  <span style="font-size:1.8em;">
                    <i class="fa fa-retweet fa-lg fa-fw"></i>
                  </span>
                </div>
                <div class="func-box-div text-right">
                  <strong>自动上架</strong>
                  <p
                    v-if="
                      this.global.KEYS.STATUS_ACTIVE ==
                        settingStatus.listingStatus
                    "
                  >
                    <span class="func-status"
                      ><el-tag type="success">
                        <i class="fa fa-cog fa-spin fa-lg"></i>
                        运行中...</el-tag
                      ></span
                    >
                  </p>
                  <p v-else>
                    <span class="func-status">
                      <el-tag type="info"
                        ><i class="fa fa-stop fa-lg"></i> 未启动</el-tag
                      ></span
                    >
                  </p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card
                shadow="hover"
                class="func-box"
                style="background-color:#67C23A"
                @click.native="turn2Page('rate/autoRate')"
              >
                <div class="func-box-div text-left">
                  <span style="font-size:1.8em;">
                    <i class="fa fa-comments fa-lg fa-fw"></i>
                  </span>
                </div>
                <div class="func-box-div text-right">
                  <strong>自动评价</strong>
                  <p
                    v-if="
                      this.global.KEYS.STATUS_ACTIVE ==
                        settingStatus.tradeRateStatus
                    "
                  >
                    <span class="func-status"
                      ><el-tag type="success">
                        <i class="fa fa-cog fa-spin fa-lg"></i>
                        运行中...</el-tag
                      ></span
                    >
                  </p>
                  <p v-else>
                    <span class="func-status">
                      <el-tag type="info"
                        ><i class="fa fa-stop fa-lg"></i> 未启动</el-tag
                      ></span
                    >
                  </p>
                </div>
              </el-card></el-col
            >
            <el-col :span="6">
              <el-card
                shadow="hover"
                class="func-box"
                style="background-color:#E6A23C"
                @click.native="turn2Page('rate/autoRate')"
              >
                <div class="func-box-div text-left">
                  <span style="font-size:1.8em;">
                    <i class="fa fa-shield fa-lg fa-fw"></i>
                  </span>
                </div>
                <div class="func-box-div text-right">
                  <strong>中差评提醒和拦截</strong>
                  <p
                    v-if="
                      this.global.KEYS.STATUS_ACTIVE ==
                        settingStatus.tradeRateStatus &&
                        settingStatus.blockStatus
                    "
                  >
                    <span class="func-status"
                      ><el-tag type="success">
                        <i class="fa fa-cog fa-spin fa-lg"></i>
                        运行中...</el-tag
                      ></span
                    >
                  </p>
                  <p v-else>
                    <span class="func-status">
                      <el-tag type="info"
                        ><i class="fa fa-stop fa-lg"></i> 未启动</el-tag
                      ></span
                    >
                  </p>
                </div>
              </el-card></el-col
            >
            <el-col :span="6">
              <el-card
                shadow="hover"
                class="func-box"
                style="background-color:#F56C6C"
                @click.native="turn2Page('stock/short')"
              >
                <div class="func-box-div text-left">
                  <span style="font-size:1.8em;">
                    <i class="fa fa-cubes fa-lg fa-fw"></i>
                  </span>
                </div>
                <div class="func-box-div text-right">
                  <strong>库存预警</strong>
                  <p
                    v-if="
                      this.global.KEYS.STATUS_ACTIVE ==
                        settingStatus.stockAlertStatus
                    "
                  >
                    <span class="func-status"
                      ><el-tag type="success">
                        <i class="fa fa-cog fa-spin fa-lg"></i>
                        运行中...</el-tag
                      ></span
                    >
                  </p>
                  <p v-else>
                    <span class="func-status">
                      <el-tag type="info"
                        ><i class="fa fa-stop fa-lg"></i> 未启动</el-tag
                      ></span
                    >
                  </p>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 店铺检测功能 -->
    <div>
      <el-row>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>店铺健康</span>
            </div>
            <div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-card
                    shadow="hover"
                    class="check-box"
                    @click.native="turn2Page('check/sameCode')"
                  >
                    <div class="check-box-div text-left">
                      <span class="check-result" style="color:#F56C6C">{{
                        score.sameItemNum
                      }}</span>
                      <p>
                        <span class="check-name">重复铺货数</span>
                      </p>
                    </div>
                    <div class="check-box-div text-right">
                      <span style="font-size:1.8em; color:#F56C6C">
                        <i class="fa fa-shopping-cart fa-lg fa-fw"></i>
                      </span>
                    </div> </el-card
                ></el-col>
                <el-col :span="12">
                  <el-card
                    shadow="hover"
                    class="check-box"
                    @click.native="turn2Page('check/checkProp')"
                  >
                    <div class="check-box-div text-left">
                      <span class="check-result" style="color:#E6A23C">{{
                        score.propDetectScore
                      }}</span>
                      <p>
                        <span class="check-name">宝贝属性健康指数</span>
                      </p>
                    </div>
                    <div class="check-box-div text-right">
                      <span style="font-size:1.8em; color:#E6A23C">
                        <i class="fa fa-th-list fa-lg fa-fw"></i>
                      </span>
                    </div> </el-card
                ></el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" style="margin-left:10px;">
            <div slot="header" class="clearfix">
              <span>热门功能</span>
            </div>
            <div>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-badge value="热门">
                    <el-button
                      type="primary"
                      plain
                      @click.native="turn2Page('check/sameCode')"
                      >重复铺货检测</el-button
                    >
                  </el-badge>
                </el-col>
                <el-col :span="6">
                  <el-badge value="热门"
                    ><el-button
                      type="primary"
                      plain
                      @click.native="turn2Page('list/setting')"
                      >自动上架</el-button
                    ></el-badge
                  ></el-col
                >
                <el-col :span="6">
                  <el-badge value="热门"
                    ><el-button
                      type="primary"
                      plain
                      @click.native="turn2Page('rate/autoRate')"
                      >中差评提醒</el-button
                    ></el-badge
                  ></el-col
                >
                <el-col :span="6"
                  ><el-button
                    type="primary"
                    plain
                    @click.native="turn2Page('rate/autoRate')"
                    >黑名单拦截</el-button
                  ></el-col
                >
              </el-row>
              <el-row :gutter="20" style="margin-top:20px">
                <el-col :span="6"
                  ><el-button
                    type="primary"
                    plain
                    @click.native="turn2Page('check/checkProp')"
                    >商品属性检测</el-button
                  ></el-col
                >
                <el-col :span="6"
                  ><el-button
                    type="primary"
                    plain
                    @click.native="turn2Page('stock/short')"
                    >库存预警</el-button
                  ></el-col
                >
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 内容 -->
    <div>
      <el-row>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="color:#409EFF"
                ><i class="fa fa-window-minimize fa-rotate-90"></i>
                站内通知</span
              >
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click.native="turn2Page('content/notice')"
                >更多</el-button
              >
            </div>
            <div>
              <el-table
                :data="noticeList"
                style="width: 100%"
                :show-header="false"
                :size="size"
                v-loading="contentLoading1"
                :element-loading-text="$t('action.loading')"
              >
                <el-table-column prop="title" min-width="200px">
                  <template slot-scope="scope">
                    <el-link
                      style="font-size:12px;"
                      :underline="false"
                      @click="openContent(scope.row)"
                      target="_blank"
                      >{{ scope.row.title }}</el-link
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="updateDate" min-width="100">
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" style="margin-left:10px;">
            <div slot="header" class="clearfix">
              <span style="color:#409EFF"
                ><i class="fa fa-window-minimize fa-rotate-90"></i> 大学堂</span
              >
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click.native="turn2Page('content/class')"
                >更多</el-button
              >
            </div>
            <div>
              <el-table
                :data="classList"
                style="width: 100%"
                :show-header="false"
                :size="size"
                v-loading="contentLoading2"
                :element-loading-text="$t('action.loading')"
              >
                <el-table-column prop="title" min-width="200px">
                  <template slot-scope="scope">
                    <el-link
                      style="font-size:12px;"
                      :underline="false"
                      @click="openContent(scope.row)"
                      target="_blank"
                      >{{ scope.row.title }}</el-link
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="updateDate" min-width="100">
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 店铺健康功能 -->
    <div v-if="1 == 2">
      <el-card class="box-card">
        <!-- <div slot="header" class="clearfix">
          <span>店铺健康指数</span>
          <el-button style="float: right; padding: 3px 0" type="text"
            >操作按钮</el-button
          >
        </div> -->
        <div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-card shadow="hover" class="check-box">
                <div class="check-box-div text-left">
                  <span class="check-result" style="color:#67C23A">8</span>
                  <p>
                    <span class="check-name">店铺健康指数</span>
                  </p>
                </div>
                <div class="check-box-div text-right">
                  <span style="font-size:1.8em; color:#67C23A">
                    <i class="fa fa-medkit fa-lg fa-fw"></i>
                  </span>
                </div> </el-card
            ></el-col>
            <el-col :span="6">
              <el-card
                shadow="hover"
                class="check-box"
                @click="turn2Page('check/sameCode')"
              >
                <div class="check-box-div text-left">
                  <span class="check-result" style="color:#F56C6C">8</span>
                  <p>
                    <span class="check-name">重复铺货数</span>
                  </p>
                </div>
                <div class="check-box-div text-right">
                  <span style="font-size:1.8em; color:#F56C6C">
                    <i class="fa fa-shopping-cart fa-lg fa-fw"></i>
                  </span>
                </div> </el-card
            ></el-col>
            <el-col :span="6">
              <el-card
                shadow="hover"
                class="check-box"
                @click="turn2Page('check/sameCode')"
              >
                <div class="check-box-div text-left">
                  <span class="check-result" style="color:#409EFF">54.8</span>
                  <p>
                    <span class="check-name">宝贝标题健康指数</span>
                  </p>
                </div>
                <div class="check-box-div text-right">
                  <span style="font-size:1.8em; color:#409EFF">
                    <i class="fa fa-book fa-lg fa-fw"></i>
                  </span>
                </div> </el-card
            ></el-col>
            <el-col :span="6">
              <el-card shadow="hover" class="check-box">
                <div class="check-box-div text-left">
                  <span class="check-result" style="color:#E6A23C">67.3</span>
                  <p>
                    <span class="check-name">宝贝属性健康指数</span>
                  </p>
                </div>
                <div class="check-box-div text-right">
                  <span style="font-size:1.8em; color:#E6A23C">
                    <i class="fa fa-th-list fa-lg fa-fw"></i>
                  </span>
                </div> </el-card
            ></el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 内容显示页面 -->
    <el-dialog
      :title="dataForm.title"
      width="900px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div
        width="800px"
        v-loading="contentDialogLoading"
        :element-loading-text="$t('action.loading')"
      >
        <el-row>
          <div>
            <span style="float:right">发布日期：{{ dataForm.updateDate }}</span>
          </div>
          <el-divider></el-divider>
        </el-row>
        <el-row><div v-html="dataForm.content" /> </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  data() {
    return {
      size: "mini",
      fit: "fill",
      adImgs: [],
      contentDialogLoading: false,
      dialogVisible: false,
      contentLoading1: false,
      noticeList: [],
      classList: [],
      contentLoading2: false,
      dataForm: {
        id: null,
        content: "",
        isTop: false
      },
      score: {
        propDetectScore: 0,
        sameItemNum: 0
      },
      settingStatus: {
        listingStatus: "",
        tradeRateStatus: "",
        blockStatus: false,
        stockAlertStatus: ""
      },
      isShowBandingAlert: true
    };
  },
  methods: {
    loadAD: function() {
      this.$api.sysparam.getList({ code: "HOME_PAGE_AD_IMAGES" }).then(res => {
        if (res.code == 200) {
          this.adImgs = res.data;
        }
      });
    },
    loadListing: function() {
      this.$api.listing.getStatus().then(res => {
        if (res.code == 200) {
          this.settingStatus.listingStatus = res.data.status;
        }
      });
    },
    loadRate: function() {
      this.$api.traderate.getProfile().then(res => {
        if (res.code == 200) {
          this.settingStatus.tradeRateStatus = res.data.status;
          this.settingStatus.blockStatus = res.data.isBlockRate;
        }
      });
    },
    loadAlert: function() {
      this.$api.stock.getAlertProfile().then(res => {
        if (res.code == 200) {
          this.settingStatus.stockAlertStatus = res.data.status;
        }
      });
    },
    loadScore: function() {
      this.$api.check.getScore().then(res => {
        if (res.code == 200) {
          if (res.data != null) {
            this.score = res.data;
          }
        }
      });
    },
    loadContent1: function() {
      this.contentLoading1 = true;
      this.$api.content.getTops({ type: "NOTICE", num: 6 }).then(res => {
        this.contentLoading1 = false;
        if (res.code == 200) {
          this.noticeList = res.data;
        }
      });
    },
    loadContent2: function() {
      this.contentLoading2 = true;
      this.$api.content.getTops({ type: "CLASS", num: 6 }).then(res => {
        this.contentLoading2 = false;
        if (res.code == 200) {
          this.classList = res.data;
        }
      });
    },
    turn2Page: function(path) {
      //console.log(path);
      this.$router.push(path);
    },
    openContent: function(data) {
      this.dialogVisible = true;
      this.contentDialogLoading = true;
      //获取数据
      this.$api.content
        .getOne(data.id)
        .then(res => {
          this.contentDialogLoading = false;
          //操作成功
          if (res.code == 200) {
            this.dataForm = res.data;
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    checkBinding: function() {
      const edzUser = JSON.parse(sessionStorage.getItem("edzUser"));
      if (edzUser) {
        if (edzUser.phoneNo && edzUser.email) {
          this.isShowBandingAlert = false;
        } else {
          this.isShowBandingAlert = true;
        }
      }
    }
  },
  mounted() {
    this.loadAD();
    this.loadScore();
    this.loadListing();
    this.loadRate();
    this.loadAlert();
    this.loadContent1();
    this.loadContent2();
    this.checkBinding();
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  .carousel {
    margin-bottom: 8px;
  }
  .bindingAlert {
    margin-bottom: 8px;
  }
  .box-card {
    margin-bottom: 8px;
    .func-box {
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      height: 100px;
      .func-box-div {
        display: inline-block;
        vertical-align: middle;
        height: 60px;
        .func-status {
          font-size: 0.8em;
        }
      }
      .text-left {
        margin-top: 10px;
        //width: 64px;
        float: left;
      }
      .text-right {
        padding-right: 20px;
        float: right;
      }
    }

    .check-box {
      color: #909399;
      text-align: center;
      background-color: #f2f6fc;
      height: 100px;
      cursor: pointer;
      .check-box-div {
        display: inline-block;
        vertical-align: middle;
        height: 60px;
        .check-result {
          font-size: 1.5em;
          font-weight: bold;
        }
        .check-name {
          font-size: 1em;
          font-weight: bold;
        }
      }
      .text-left {
        width: 130px;
        float: left;
      }
      .text-right {
        padding-right: 20px;
        float: right;
      }
    }
  }

  //重新设置Header的高度
  /deep/ .el-card {
    .el-card__header {
      //padding: 18px 20px;
      padding: 8px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue